var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 163.43 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;clip-rule:evenodd;}.cls-2{isolation:isolate;}.cls-3,.cls-36{fill:#231f20;}.cls-4{clip-path:url(#clip-path);}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17{opacity:0.28;}.cls-18,.cls-32,.cls-35,.cls-48,.cls-49{fill:#fff;}.cls-19{fill:url(#linear-gradient-13);}.cls-20{fill:url(#linear-gradient-14);}.cls-21{fill:url(#linear-gradient-15);}.cls-22{fill:url(#linear-gradient-16);}.cls-23{fill:url(#linear-gradient-17);}.cls-24{fill:url(#linear-gradient-18);}.cls-25{fill:url(#linear-gradient-19);}.cls-26{fill:url(#linear-gradient-20);}.cls-27{fill:url(#linear-gradient-21);}.cls-28{fill:url(#linear-gradient-22);}.cls-29{fill:url(#linear-gradient-23);}.cls-30{fill:url(#linear-gradient-24);}.cls-31{fill:url(#linear-gradient-25);}.cls-32{opacity:0.39;}.cls-33{fill:#6f0000;}.cls-34{opacity:0.44;}.cls-36,.cls-37{mix-blend-mode:color-burn;}.cls-37{fill:#7e8083;}.cls-38{fill:url(#linear-gradient-26);}.cls-39{fill:url(#linear-gradient-27);}.cls-40,.cls-45,.cls-46{mix-blend-mode:overlay;}.cls-40{fill:url(#linear-gradient-28);}.cls-41{fill:url(#linear-gradient-29);}.cls-42{fill:url(#linear-gradient-30);}.cls-43{fill:url(#linear-gradient-31);}.cls-44{fill:url(#linear-gradient-32);}.cls-45{fill:url(#linear-gradient-33);}.cls-46{fill:url(#linear-gradient-34);}.cls-47{fill:url(#linear-gradient-35);}.cls-48{opacity:0.63;}.cls-49{opacity:0.31;}.cls-50{fill:url(#linear-gradient-36);}.cls-51{fill:url(#linear-gradient-37);}.cls-52{fill:url(#linear-gradient-38);}.cls-53{fill:url(#linear-gradient-39);}.cls-54{fill:url(#linear-gradient-40);}.cls-55{fill:url(#linear-gradient-41);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.36 1.9 149.76 1.9 152.06 2.47 153.94 4.27 155.23 6.87 155.66 10.18 155.66 209.33 155.23 212.5 153.94 215.16 152.06 216.89 149.76 217.54 9.36 217.54 7.05 216.89 5.25 215.16 3.96 212.5 3.6 209.33 3.6 10.18 3.96 6.87 5.25 4.27 7.05 2.47 9.36 1.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -23.71,
    y1: 153.29,
    x2: 215.29,
    y2: 153.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 102.36,
    y1: 155.84,
    x2: 280.29,
    y2: 155.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee492f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94070a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -916.25,
    y1: 369.82,
    x2: -776.29,
    y2: 206.53,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -914.51,
    y1: 371.3,
    x2: -774.56,
    y2: 208.02,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -912.78,
    y1: 372.79,
    x2: -772.83,
    y2: 209.5,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -911.05,
    y1: 374.27,
    x2: -771.1,
    y2: 210.98,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -909.32,
    y1: 375.75,
    x2: -769.37,
    y2: 212.47,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1064.7,
    y1: 508.47,
    x2: -766.56,
    y2: 160.63,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1061.02,
    y1: 511.63,
    x2: -762.87,
    y2: 163.78,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1057.32,
    y1: 514.79,
    x2: -759.18,
    y2: 166.95,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -812.08,
    y1: 440.28,
    x2: -701.24,
    y2: 231.97,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -817.72,
    y1: 437.27,
    x2: -706.88,
    y2: 228.97,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -808.33,
    y1: 443.94,
    x2: -697.49,
    y2: 235.64,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -834.63,
    y1: 428.28,
    x2: -723.79,
    y2: 219.96,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -840.28,
    y1: 425.27,
    x2: -729.44,
    y2: 216.96,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -842.05,
    y1: 555.23,
    x2: -706.37,
    y2: 354.57,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -842.86,
    y1: 554.69,
    x2: -707.18,
    y2: 354.02,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -843.69,
    y1: 554.13,
    x2: -708.01,
    y2: 353.46,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -844.51,
    y1: 553.58,
    x2: -708.82,
    y2: 352.9,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -760.95,
    y1: 542.74,
    x2: -625.26,
    y2: 342.06,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -989.96,
    y1: 500.46,
    x2: -691.81,
    y2: 152.61,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -986.28,
    y1: 503.62,
    x2: -688.12,
    y2: 155.77,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -982.58,
    y1: 506.77,
    x2: -684.44,
    y2: 158.94,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -978.89,
    y1: 509.93,
    x2: -680.76,
    y2: 162.1,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -975.22,
    y1: 513.09,
    x2: -677.07,
    y2: 165.24,
    gradientTransform: "translate(-719.12 488.83) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -49.92,
    y1: 70.96,
    x2: 108.08,
    y2: 244.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -63.03,
    y1: 82.86,
    x2: 94.97,
    y2: 256.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -65.7,
    y1: 85.29,
    x2: 92.3,
    y2: 259.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -39.77,
    y1: 61.73,
    x2: 118.24,
    y2: 235.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -15.18,
    y1: 39.42,
    x2: 142.81,
    y2: 213.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 12.38,
    y1: 14.39,
    x2: 170.38,
    y2: 188.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 71.77,
    y1: -39.54,
    x2: 229.77,
    y2: 134.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 64.36,
    y1: -32.82,
    x2: 222.36,
    y2: 141.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 45.86,
    y1: -16.02,
    x2: 203.86,
    y2: 157.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -32.71,
    y1: 55.33,
    x2: 125.28,
    y2: 229.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 50.23,
    y1: 149.04,
    x2: 246.2,
    y2: 149.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 33.58,
    y1: 262.27,
    x2: 180.53,
    y2: 111.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 34.04,
    y1: 262.71,
    x2: 180.98,
    y2: 111.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 34.5,
    y1: 263.15,
    x2: 181.43,
    y2: 112.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 34.96,
    y1: 263.6,
    x2: 181.89,
    y2: 112.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 35.42,
    y1: 264.04,
    x2: 182.35,
    y2: 113.32,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -2234.39,
    y: -519.25,
    width: 2406.31,
    height: 1210.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -23.71,
    y: -138.71,
    width: 239,
    height: 584
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "273.08 60.13 280.29 86.43 237.01 101.78 230.59 141.97 189.73 153.66 186.52 192.38 144.84 203.34 136.82 247.18 102.36 251.55 273.08 60.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.9,204.58s-13.23-2.14-18.54,5.41a5.35,5.35,0,0,0,6.62,7.94,3.89,3.89,0,0,0,2.16-4s1.75,2.67-2.79,7c-.65.65-1.44,1.39-2.41,2.21l2.51,1.77c.45-1.19.86-2.18,1.27-3,2.55-5.74,5.65-5,5.65-5a3.85,3.85,0,0,0-3,3.36,5.35,5.35,0,0,0,9.7,3.58C128.37,216.33,121.9,204.58,121.9,204.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M135.78,184.89s-13.23-2.13-18.54,5.42a5.35,5.35,0,0,0,6.62,7.93,3.89,3.89,0,0,0,2.16-4s1.75,2.67-2.79,7c-.66.66-1.45,1.4-2.42,2.21l2.5,1.77c.46-1.18.88-2.19,1.29-3,2.55-5.74,5.65-5,5.65-5-1.95.3-2.72,2-3,3.37a5.35,5.35,0,0,0,9.7,3.57C142.24,196.64,135.78,184.89,135.78,184.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M149.65,165.2s-13.23-2.11-18.54,5.41a5.36,5.36,0,0,0,6.63,7.95c1.2-.76,2.52-2.05,2.15-4,0,0,1.76,2.68-2.78,7-.67.67-1.45,1.4-2.42,2.21l2.51,1.77c.44-1.18.86-2.18,1.26-3,2.56-5.74,5.67-5,5.67-5-2,.31-2.72,2-3,3.37a5.27,5.27,0,0,0,2.24,4.86,5.33,5.33,0,0,0,7.45-1.29C156.11,177,149.65,165.2,149.65,165.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M163.52,145.52s-13.23-2.14-18.54,5.41a5.36,5.36,0,0,0,1.3,7.46,5.3,5.3,0,0,0,5.34.47c1.18-.74,2.52-2,2.14-4,0,0,1.76,2.67-2.78,7-.67.66-1.46,1.39-2.41,2.21l2.51,1.76c.43-1.18.86-2.16,1.26-3,2.56-5.73,5.67-5,5.67-5-2,.31-2.73,2-3,3.38a5.29,5.29,0,0,0,2.24,4.86,5.35,5.35,0,0,0,7.45-1.29C170,157.27,163.52,145.52,163.52,145.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M177.4,125.83s-13.23-2.12-18.55,5.42a5.36,5.36,0,0,0,6.63,7.94c1.2-.76,2.52-2.06,2.15-4,0,0,1.75,2.67-2.78,7-.66.66-1.45,1.4-2.43,2.21l2.52,1.78c.45-1.19.87-2.2,1.27-3,2.56-5.74,5.67-5,5.67-5a3.87,3.87,0,0,0-3,3.38,5.34,5.34,0,0,0,9.68,3.57C183.85,137.59,177.4,125.83,177.4,125.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M137.54,218.43S109.34,213.87,98,230a11.4,11.4,0,0,0,14.11,16.9c2.55-1.59,5.38-4.35,4.59-8.5,0,0,3.74,5.7-5.93,15-1.39,1.38-3.07,3-5.13,4.69l5.33,3.77c1-2.53,1.84-4.63,2.71-6.42,5.44-12.23,12.05-10.62,12.05-10.62-4.14.64-5.8,4.21-6.45,7.17A11.4,11.4,0,0,0,140,259.51C151.32,243.46,137.54,218.43,137.54,218.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M167.1,176.48s-28.19-4.54-39.5,11.54a11.39,11.39,0,0,0,14.11,16.89c2.55-1.58,5.37-4.36,4.59-8.5,0,0,3.74,5.7-5.94,14.93-1.41,1.42-3.09,3-5.15,4.71l5.33,3.78c1-2.52,1.86-4.66,2.73-6.44,5.45-12.23,12-10.61,12-10.61-4.16.64-5.8,4.22-6.45,7.19a11.39,11.39,0,0,0,20.65,7.61C180.85,201.5,167.1,176.48,167.1,176.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M196.64,134.53s-28.17-4.5-39.48,11.54A11.4,11.4,0,0,0,171.27,163c2.55-1.63,5.37-4.38,4.59-8.53,0,0,3.74,5.7-5.93,14.94-1.42,1.42-3.09,3-5.16,4.7l5.36,3.77c.94-2.51,1.83-4.64,2.68-6.41,5.45-12.24,12.08-10.64,12.08-10.64-4.17.68-5.8,4.24-6.45,7.19a11.37,11.37,0,0,0,20.62,7.6C210.4,159.57,196.64,134.53,196.64,134.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M22.61,189.18s-28.19-4.56-39.5,11.52a11.38,11.38,0,0,0,2.75,15.88,11.38,11.38,0,0,0,11.36,1c2.55-1.59,5.37-4.35,4.59-8.5,0,0,3.74,5.7-5.94,15-1.39,1.38-3.07,2.95-5.13,4.69l5.33,3.78c1-2.54,1.84-4.64,2.71-6.43,5.45-12.23,12.05-10.62,12.05-10.62-4.14.64-5.8,4.21-6.45,7.17a11.4,11.4,0,0,0,20.68,7.62C36.39,214.2,22.61,189.18,22.61,189.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M52.18,147.23S24,142.69,12.67,158.77a11.39,11.39,0,0,0,14.11,16.89c2.55-1.58,5.37-4.35,4.59-8.5,0,0,3.74,5.7-5.94,14.93-1.41,1.42-3.08,3-5.15,4.71l5.34,3.78c1-2.52,1.85-4.66,2.73-6.44,5.44-12.23,12-10.61,12-10.61-4.17.64-5.8,4.23-6.45,7.19a11.39,11.39,0,0,0,20.65,7.61C65.93,172.25,52.18,147.23,52.18,147.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M81.72,105.28s-28.18-4.5-39.49,11.53a11.4,11.4,0,0,0,14.11,16.94c2.56-1.63,5.38-4.38,4.59-8.52,0,0,3.74,5.69-5.93,14.93-1.41,1.43-3.09,3-5.15,4.69l5.35,3.78c.94-2.51,1.84-4.64,2.69-6.41C63.33,130,70,131.58,70,131.58c-4.17.68-5.8,4.24-6.45,7.19a11.22,11.22,0,0,0,4.77,10.34,11.33,11.33,0,0,0,15.86-2.74C95.47,130.32,81.72,105.28,81.72,105.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M90.59,50.69S62.42,46.14,51.11,62.22a11.4,11.4,0,0,0,14.13,16.9c2.53-1.59,5.37-4.34,4.57-8.5,0,0,3.74,5.69-5.94,14.94-1.41,1.41-3.09,3-5.12,4.7L64.1,94c.92-2.51,1.83-4.61,2.69-6.42C72.23,75.39,78.86,77,78.86,77c-4.17.65-5.83,4.22-6.48,7.2a11.27,11.27,0,0,0,4.77,10.35A11.38,11.38,0,0,0,93,91.77C104.37,75.73,90.59,50.69,90.59,50.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M140.82,21.42S112.65,16.89,101.32,33a11.41,11.41,0,0,0,14.13,16.91c2.55-1.62,5.35-4.39,4.57-8.51,0,0,3.73,5.68-5.92,14.93-1.41,1.41-3.09,3-5.17,4.7l5.35,3.79c1-2.53,1.86-4.67,2.71-6.44,5.47-12.24,12.07-10.64,12.07-10.64-4.16.66-5.82,4.25-6.45,7.21a11.38,11.38,0,0,0,20.63,7.6C154.57,46.46,140.82,21.42,140.82,21.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M170.38-20.51S142.21-25,130.88-9a11.38,11.38,0,0,0,2.75,15.87,11.37,11.37,0,0,0,11.36,1c2.57-1.6,5.37-4.34,4.61-8.5,0,0,3.72,5.68-6,14.94-1.39,1.42-3.09,3-5.15,4.69l5.35,3.78c1-2.53,1.84-4.63,2.69-6.42C152,4.16,158.63,5.77,158.63,5.77c-4.19.66-5.83,4.24-6.48,7.19a11.4,11.4,0,0,0,20.65,7.62C184.14,4.51,170.38-20.51,170.38-20.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M6.86,106.36s-28.2-4.54-39.51,11.54a11.37,11.37,0,0,0,2.76,15.87,11.33,11.33,0,0,0,11.35,1c2.55-1.58,5.37-4.36,4.59-8.5,0,0,3.74,5.7-5.93,14.93-1.42,1.42-3.09,3-5.16,4.71l5.34,3.77c1-2.52,1.85-4.65,2.73-6.43,5.44-12.23,12-10.61,12-10.61-4.17.64-5.8,4.22-6.45,7.19A11.44,11.44,0,0,0-6.6,150.21a11.42,11.42,0,0,0,15.88-2.76C20.61,131.37,6.86,106.36,6.86,106.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M36.4,64.41S8.22,59.91-3.09,75.94A11.4,11.4,0,0,0,11,92.87c2.56-1.62,5.38-4.38,4.6-8.52,0,0,3.74,5.7-5.94,14.94-1.41,1.42-3.09,3-5.15,4.69l5.35,3.77q1.41-3.75,2.69-6.4C18,89.11,24.64,90.71,24.64,90.71c-4.16.67-5.8,4.23-6.45,7.19a11.37,11.37,0,0,0,20.63,7.59C50.15,89.45,36.4,64.41,36.4,64.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M65.94,22.48S37.76,17.93,26.45,34a11.41,11.41,0,0,0,14.14,16.9c2.53-1.59,5.37-4.34,4.57-8.5,0,0,3.74,5.69-5.94,14.94-1.41,1.41-3.09,3-5.13,4.71l5.35,3.76c.92-2.52,1.84-4.62,2.69-6.43C47.57,47.19,54.2,48.77,54.2,48.77,50,49.42,48.38,53,47.73,56A11.27,11.27,0,0,0,52.5,66.32a11.38,11.38,0,0,0,15.88-2.75C79.71,47.52,65.94,22.48,65.94,22.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M95.5-19.45S67.33-24,56-7.91A11.39,11.39,0,0,0,58.75,8,11.49,11.49,0,0,0,70.13,9C72.68,7.37,75.48,4.61,74.7.49c0,0,3.74,5.68-5.92,14.92-1.41,1.42-3.09,3-5.17,4.71L69,23.9c1-2.53,1.86-4.67,2.71-6.44C77.14,5.23,83.74,6.83,83.74,6.83c-4.16.66-5.82,4.25-6.45,7.21a11.38,11.38,0,0,0,20.63,7.6C109.25,5.58,95.5-19.45,95.5-19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M11.94-8.62s-28.17-4.52-39.5,11.55a11.39,11.39,0,0,0,2.75,15.88,11.49,11.49,0,0,0,11.38,1c2.55-1.63,5.35-4.39,4.56-8.51,0,0,3.75,5.68-5.91,14.92-1.41,1.42-3.09,3-5.17,4.71l5.35,3.78c1-2.53,1.86-4.67,2.71-6.44C-6.42,16.06.18,17.67.18,17.67c-4.16.66-5.82,4.25-6.45,7.21a11.38,11.38,0,0,0,20.63,7.6C25.69,16.42,11.94-8.62,11.94-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M75.91,211.16s-28.2-4.56-39.51,11.52a11.39,11.39,0,0,0,14.11,16.9c2.55-1.59,5.37-4.34,4.59-8.5,0,0,3.74,5.7-5.94,14.95-1.41,1.38-3.09,3-5.15,4.69l5.36,3.78c.94-2.53,1.81-4.64,2.68-6.43,5.47-12.23,12.08-10.62,12.08-10.62-4.15.64-5.83,4.21-6.48,7.17a11.42,11.42,0,0,0,20.7,7.62C89.66,236.19,75.91,211.16,75.91,211.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M105.47,169.21s-28.2-4.53-39.53,11.55a11.39,11.39,0,0,0,14.11,16.88c2.55-1.57,5.4-4.35,4.61-8.5,0,0,3.74,5.7-5.93,14.93-1.41,1.42-3.09,3-5.18,4.72l5.36,3.77c.94-2.52,1.86-4.66,2.71-6.44,5.44-12.23,12.07-10.6,12.07-10.6-4.17.63-5.82,4.22-6.45,7.18a11.39,11.39,0,0,0,20.65,7.61C119.2,194.23,105.47,169.21,105.47,169.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M135,127.26s-28.18-4.5-39.49,11.54a11.41,11.41,0,0,0,14.13,16.93c2.56-1.62,5.38-4.38,4.6-8.52,0,0,3.71,5.7-6,14.94-1.41,1.42-3.09,3-5.15,4.69l5.35,3.77c1-2.51,1.86-4.63,2.71-6.41,5.44-12.23,12.07-10.63,12.07-10.63-4.19.67-5.82,4.23-6.47,7.19a11.39,11.39,0,0,0,20.65,7.59C148.76,152.3,135,127.26,135,127.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M164.55,85.34S136.38,80.79,125,96.87a11.41,11.41,0,0,0,14.14,16.9c2.55-1.59,5.37-4.35,4.59-8.5,0,0,3.74,5.69-5.94,14.94-1.41,1.41-3.09,3-5.15,4.7l5.35,3.76c.94-2.52,1.84-4.61,2.69-6.42,5.47-12.21,12.07-10.62,12.07-10.62-4.16.65-5.82,4.22-6.45,7.2a11.29,11.29,0,0,0,4.75,10.35,11.41,11.41,0,0,0,15.9-2.76C178.32,110.38,164.55,85.34,164.55,85.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M194.11,43.4s-28.19-4.52-39.5,11.54a11.4,11.4,0,0,0,14.11,16.92c2.57-1.63,5.37-4.4,4.59-8.52,0,0,3.74,5.68-5.94,14.93-1.39,1.41-3.09,3-5.15,4.7l5.35,3.79c.94-2.53,1.84-4.67,2.69-6.44,5.47-12.24,12.1-10.64,12.1-10.64-4.17.66-5.83,4.26-6.48,7.21a11.4,11.4,0,0,0,20.65,7.61C207.86,68.44,194.11,43.4,194.11,43.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M191.82,18.16a97.54,97.54,0,1,0-97.53,97.53A97.54,97.54,0,0,0,191.82,18.16Zm-160.6,0A63.07,63.07,0,1,1,94.29,81.22,63.06,63.06,0,0,1,31.22,18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M171.59,79.61a9.64,9.64,0,0,1,.73-2.51c.1-.22.2-.43.32-.64s.13-.27.1-.3h0a.07.07,0,0,0,0-.05c-.1-.09-.62.26-.73.31a9.43,9.43,0,0,1-2.74.78c-2.5.35-4.83-.1-6.63,1a4.55,4.55,0,0,0-2.2,3.43,2.56,2.56,0,0,0,.67,2,2.71,2.71,0,0,0,2.52.65,4.52,4.52,0,0,0,1.51-.62c-.93,1.4-1,3.06,0,4a2.52,2.52,0,0,0,2,.71,4.53,4.53,0,0,0,3.47-2.14C171.62,84.44,171.21,82.1,171.59,79.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M162,89.19a9.4,9.4,0,0,1,.72-2.52c.1-.21.2-.42.32-.63s.13-.27.1-.3,0,0,0,0a.07.07,0,0,0,0,0c-.1-.09-.62.26-.73.31a9.66,9.66,0,0,1-2.74.78c-2.5.34-4.83-.1-6.63,1a4.53,4.53,0,0,0-2.2,3.43,2.53,2.53,0,0,0,.68,2,2.69,2.69,0,0,0,2.51.65,4.43,4.43,0,0,0,1.51-.62c-.93,1.4-1,3.06,0,4a2.52,2.52,0,0,0,2,.71A4.56,4.56,0,0,0,161,95.8C162,94,161.63,91.68,162,89.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M151.84,98.84a9.19,9.19,0,0,1,1.46-2.17,4.7,4.7,0,0,1,.49-.51c.15-.14.21-.22.19-.26a.05.05,0,0,0,0,0,0,0,0,0,0,0,0c-.06-.11-.66.06-.78.08a9.73,9.73,0,0,1-2.85-.09c-2.49-.43-4.57-1.57-6.6-1.11a4.53,4.53,0,0,0-3.14,2.6,2.57,2.57,0,0,0,0,2.14,2.71,2.71,0,0,0,2.21,1.38,4.32,4.32,0,0,0,1.62-.13,3.22,3.22,0,0,0-1.26,3.82,2.55,2.55,0,0,0,1.72,1.29,4.52,4.52,0,0,0,4-1C150.4,103.45,150.72,101.1,151.84,98.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M139.81,105.06a9.45,9.45,0,0,1,1.45-2.17c.16-.17.32-.34.5-.51s.2-.22.19-.26a.05.05,0,0,0,0,0s0,0,0,0-.66,0-.78.07a9.71,9.71,0,0,1-2.85-.09c-2.49-.43-4.57-1.56-6.6-1.11a4.53,4.53,0,0,0-3.14,2.6,2.56,2.56,0,0,0,0,2.15,2.76,2.76,0,0,0,2.2,1.38,4.59,4.59,0,0,0,1.63-.14c-1.31,1.06-1.87,2.62-1.26,3.82a2.53,2.53,0,0,0,1.71,1.29,4.54,4.54,0,0,0,4-1C138.37,109.68,138.69,107.32,139.81,105.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M127.47,112.09a9.65,9.65,0,0,1,2.06-1.62c.2-.11.41-.22.63-.32s.26-.15.26-.19l0,0s0,0,0,0-.64-.16-.76-.18a9.35,9.35,0,0,1-2.68-1c-2.23-1.19-3.86-2.92-5.93-3.12a4.56,4.56,0,0,0-3.79,1.49,2.56,2.56,0,0,0-.65,2,2.73,2.73,0,0,0,1.66,2,4.47,4.47,0,0,0,1.58.38,3.22,3.22,0,0,0-2.38,3.24,2.59,2.59,0,0,0,1.22,1.76,4.6,4.6,0,0,0,4.07.29C124.66,116,125.7,113.88,127.47,112.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M114.1,114.24a9.37,9.37,0,0,1,2.06-1.61l.63-.33c.18-.08.26-.14.25-.18a.05.05,0,0,0,0,0s0,0,0,0-.65-.15-.76-.17a9.86,9.86,0,0,1-2.69-1c-2.22-1.18-3.85-2.91-5.92-3.11a4.56,4.56,0,0,0-3.8,1.49,2.59,2.59,0,0,0-.64,2,2.69,2.69,0,0,0,1.66,2,4.48,4.48,0,0,0,1.58.39c-1.57.59-2.59,1.89-2.38,3.23a2.55,2.55,0,0,0,1.22,1.76,4.53,4.53,0,0,0,4.07.29C111.29,118.18,112.32,116,114.1,114.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M100.72,116.4a9.55,9.55,0,0,1,2.06-1.61c.21-.12.41-.23.63-.33s.27-.14.26-.19l0,0a0,0,0,0,0,0,0c0-.13-.65-.15-.77-.18a9.46,9.46,0,0,1-2.68-1c-2.23-1.19-3.85-2.91-5.92-3.11a4.53,4.53,0,0,0-3.8,1.49,2.58,2.58,0,0,0-.64,2,2.71,2.71,0,0,0,1.66,2,4.27,4.27,0,0,0,1.58.38,3.2,3.2,0,0,0-2.38,3.24,2.55,2.55,0,0,0,1.22,1.76,4.56,4.56,0,0,0,4.07.29C97.91,120.33,99,118.2,100.72,116.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M86.8,116.23a9.51,9.51,0,0,1,2.47-.88,5.12,5.12,0,0,1,.7-.11c.2,0,.29-.06.3-.1a0,0,0,0,0,0,0s0,0,0,0-.57-.35-.67-.41a9.61,9.61,0,0,1-2.24-1.77c-1.74-1.82-2.74-4-4.65-4.82a4.56,4.56,0,0,0-4.07.22A2.59,2.59,0,0,0,77.4,110a2.7,2.7,0,0,0,.95,2.42,4.26,4.26,0,0,0,1.38.86c-1.68.07-3.06,1-3.28,2.33a2.52,2.52,0,0,0,.61,2,4.56,4.56,0,0,0,3.77,1.56C82.9,119.08,84.56,117.38,86.8,116.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M73.43,114.07a9.43,9.43,0,0,1,2.46-.88l.7-.11c.2,0,.3-.06.31-.1s0,0,0,0,0,0,0,0-.57-.35-.67-.41A9.61,9.61,0,0,1,74,110.73c-1.74-1.82-2.75-4-4.65-4.81a4.53,4.53,0,0,0-4.07.22A2.53,2.53,0,0,0,64,107.88a2.7,2.7,0,0,0,1,2.41,4.09,4.09,0,0,0,1.38.86,3.23,3.23,0,0,0-3.29,2.33,2.58,2.58,0,0,0,.61,2,4.53,4.53,0,0,0,3.77,1.56C69.53,116.92,71.18,115.22,73.43,114.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M59.86,110.8a9.41,9.41,0,0,1,2.61-.07,6,6,0,0,1,.7.11c.2,0,.3,0,.32,0s0,0,0,0,0,0,.05,0-.44-.51-.52-.59a9.63,9.63,0,0,1-1.57-2.38c-1.09-2.28-1.37-4.64-2.91-6a4.58,4.58,0,0,0-3.94-1.06A2.59,2.59,0,0,0,52.85,102a2.75,2.75,0,0,0,.15,2.6,4.5,4.5,0,0,0,1,1.25c-1.61-.46-3.21,0-3.84,1.18a2.57,2.57,0,0,0-.06,2.14,4.52,4.52,0,0,0,3.1,2.65C55.26,112.28,57.36,111.19,59.86,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M47.82,104.57a9.5,9.5,0,0,1,2.62-.06,6,6,0,0,1,.7.11c.2,0,.3,0,.32,0a.06.06,0,0,0,0,0s0,0,0,0-.43-.51-.51-.6a9.71,9.71,0,0,1-1.58-2.37c-1.08-2.28-1.36-4.64-2.91-6a4.52,4.52,0,0,0-3.93-1.06,2.59,2.59,0,0,0-1.74,1.26,2.75,2.75,0,0,0,.15,2.6,4.47,4.47,0,0,0,1,1.24,3.21,3.21,0,0,0-3.84,1.19,2.57,2.57,0,0,0-.06,2.14,4.52,4.52,0,0,0,3.09,2.65C43.23,106.06,45.33,105,47.82,104.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M35.39,98a9.87,9.87,0,0,1,2.51.73c.21.1.42.2.63.32s.27.13.31.1,0,0,0,0h0c.09-.1-.26-.62-.31-.73a9.75,9.75,0,0,1-.78-2.74c-.34-2.5.11-4.83-.94-6.63a4.57,4.57,0,0,0-3.43-2.2,2.58,2.58,0,0,0-2,.67A2.74,2.74,0,0,0,30.74,90a4.39,4.39,0,0,0,.62,1.5,3.22,3.22,0,0,0-4,0,2.55,2.55,0,0,0-.71,2A4.54,4.54,0,0,0,28.78,97C30.55,98,32.89,97.63,35.39,98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M25.81,88.44a9.34,9.34,0,0,1,2.51.72c.21.1.42.2.63.32s.28.13.31.1,0,0,0,0h0c.09-.1-.25-.62-.31-.73a9.66,9.66,0,0,1-.78-2.74c-.34-2.5.11-4.83-.94-6.63a4.55,4.55,0,0,0-3.43-2.2,2.57,2.57,0,0,0-2,.68,2.71,2.71,0,0,0-.64,2.51,4.41,4.41,0,0,0,.61,1.51,3.21,3.21,0,0,0-4,0,2.6,2.6,0,0,0-.71,2,4.54,4.54,0,0,0,2.15,3.47C21,88.46,23.32,88.05,25.81,88.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M15.26,78.91a9.19,9.19,0,0,1,2.17,1.46,5.9,5.9,0,0,1,.51.49c.14.15.22.21.26.19s0,0,0,0h.05c.11-.07-.06-.67-.08-.79a9.73,9.73,0,0,1,.09-2.85c.43-2.48,1.57-4.57,1.11-6.6a4.53,4.53,0,0,0-2.6-3.14,2.54,2.54,0,0,0-2.14,0,2.68,2.68,0,0,0-1.38,2.2,4.32,4.32,0,0,0,.13,1.62,3.21,3.21,0,0,0-3.82-1.26A2.57,2.57,0,0,0,8.29,72a4.52,4.52,0,0,0,1,4C10.65,77.47,13,77.79,15.26,78.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M9,66.88a9.19,9.19,0,0,1,2.17,1.46c.17.15.34.32.51.49s.22.21.26.19a.05.05,0,0,0,0,0h.05c.11-.06-.06-.66-.08-.78a9.73,9.73,0,0,1,.09-2.85c.43-2.49,1.57-4.57,1.11-6.6a4.56,4.56,0,0,0-2.6-3.14,2.56,2.56,0,0,0-2.15,0A2.73,2.73,0,0,0,7,57.84a4.55,4.55,0,0,0,.14,1.62c-1.06-1.31-2.62-1.87-3.82-1.26a2.57,2.57,0,0,0-1.29,1.72,4.52,4.52,0,0,0,1,3.95C4.42,65.44,6.78,65.76,9,66.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2.82,54.85A9.4,9.4,0,0,1,5,56.31c.17.15.34.31.51.49s.22.21.25.19,0,0,0,0h0c.12-.06-.05-.66-.07-.78a9.39,9.39,0,0,1,.09-2.85c.43-2.49,1.56-4.57,1.11-6.6a4.56,4.56,0,0,0-2.6-3.14,2.6,2.6,0,0,0-2.15,0A2.74,2.74,0,0,0,.82,45.81,4.54,4.54,0,0,0,1,47.43a3.21,3.21,0,0,0-3.82-1.26,2.61,2.61,0,0,0-1.29,1.71,4.57,4.57,0,0,0,1,4C-1.8,53.41.56,53.73,2.82,54.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-1.23,41.53A9.12,9.12,0,0,1,.39,43.59c.11.2.22.41.32.63s.15.26.19.26l0,0s0,0,0,0,.15-.65.17-.76a9.66,9.66,0,0,1,1-2.68C3.31,38.79,5,37.16,5.24,35.09A4.56,4.56,0,0,0,3.75,31.3a2.56,2.56,0,0,0-2-.65,2.73,2.73,0,0,0-2,1.66,4.7,4.7,0,0,0-.38,1.58,3.2,3.2,0,0,0-3.24-2.38,2.59,2.59,0,0,0-1.76,1.22A4.56,4.56,0,0,0-6,36.8C-5.16,38.72-3,39.76-1.23,41.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-3.38,28.16a9.37,9.37,0,0,1,1.61,2.06q.17.3.33.63c.08.18.14.26.18.25a.05.05,0,0,0,0,0s0,0,0,0,.15-.65.17-.77a9.92,9.92,0,0,1,1-2.68c1.18-2.22,2.91-3.85,3.11-5.92a4.56,4.56,0,0,0-1.49-3.8,2.59,2.59,0,0,0-2.05-.64,2.69,2.69,0,0,0-2,1.66,4.48,4.48,0,0,0-.39,1.58c-.59-1.57-1.89-2.59-3.23-2.38a2.55,2.55,0,0,0-1.76,1.22,4.53,4.53,0,0,0-.29,4.07C-7.32,25.34-5.18,26.38-3.38,28.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-4.36,14.23a9.51,9.51,0,0,1,.88,2.47c0,.22.08.46.11.7s.06.29.1.3,0,0,0,0,0,0,0,0,.35-.56.41-.67A9.61,9.61,0,0,1-1,14.8C.8,13.06,3,12.06,3.8,10.16a4.58,4.58,0,0,0-.23-4.08A2.56,2.56,0,0,0,1.83,4.83a2.7,2.7,0,0,0-2.41,1,4.26,4.26,0,0,0-.86,1.38A3.21,3.21,0,0,0-3.77,3.88a2.51,2.51,0,0,0-2.05.61A4.56,4.56,0,0,0-7.38,8.26C-7.21,10.33-5.51,12-4.36,14.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M-2.21.86a9.82,9.82,0,0,1,.89,2.46c0,.23.08.47.11.71s.05.29.09.3,0,0,0,0l0,0c.13,0,.35-.57.41-.67A9.57,9.57,0,0,1,1.13,1.43C3-.31,5.11-1.31,6-3.22a4.53,4.53,0,0,0-.22-4.07A2.56,2.56,0,0,0,4-8.54a2.7,2.7,0,0,0-2.42.95A4.43,4.43,0,0,0,.71-6.21,3.2,3.2,0,0,0-1.61-9.49a2.53,2.53,0,0,0-2.06.61A4.53,4.53,0,0,0-5.22-5.12C-5.06-3-3.35-1.38-2.21.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M33.6,15a9.67,9.67,0,0,1-.78-2.49c0-.23-.07-.47-.09-.71s0-.29-.08-.3,0,0,0,0,0,0,0,0-.38.55-.44.66a9.85,9.85,0,0,1-1.85,2.17c-1.89,1.66-4.08,2.58-5,4.45a4.54,4.54,0,0,0,.06,4.08A2.58,2.58,0,0,0,27,24.2a2.69,2.69,0,0,0,2.45-.86A4.31,4.31,0,0,0,30.41,22a3.21,3.21,0,0,0,2.19,3.37,2.58,2.58,0,0,0,2.08-.53,4.55,4.55,0,0,0,1.7-3.71C36.3,19.06,34.66,17.33,33.6,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M36.28,1.77a9.62,9.62,0,0,1-.78-2.5c0-.23-.07-.46-.09-.7s0-.3-.08-.31a0,0,0,0,0,0,0s0,0,0,0-.38.56-.44.66A9.63,9.63,0,0,1,33,1.07c-1.89,1.67-4.08,2.58-5,4.45A4.57,4.57,0,0,0,28,9.6a2.58,2.58,0,0,0,1.69,1.32,2.73,2.73,0,0,0,2.46-.85,4.39,4.39,0,0,0,.91-1.35,3.21,3.21,0,0,0,2.19,3.37,2.58,2.58,0,0,0,2.08-.53,4.5,4.5,0,0,0,1.7-3.7C39,5.78,37.34,4.06,36.28,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M152.25,1.55a9.82,9.82,0,0,1,1.69,2c.12.2.24.4.35.62s.15.25.2.25l0,0s0,0,0,0,.13-.65.15-.77a9.59,9.59,0,0,1,.86-2.72c1.1-2.27,2.76-4,2.88-6a4.57,4.57,0,0,0-1.64-3.74,2.56,2.56,0,0,0-2.07-.56,2.73,2.73,0,0,0-1.93,1.74,4.5,4.5,0,0,0-.32,1.59,3.21,3.21,0,0,0-3.33-2.25,2.6,2.6,0,0,0-1.71,1.29A4.61,4.61,0,0,0,147.32-3C148.21-1.1,150.38-.15,152.25,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M154.93,14.83a9.26,9.26,0,0,1,1.69,2c.12.19.24.4.35.61s.16.26.2.25,0,0,0,0l0,0c.13,0,.13-.66.15-.78a9.52,9.52,0,0,1,.86-2.71c1.1-2.27,2.76-4,2.88-6a4.53,4.53,0,0,0-1.64-3.74,2.55,2.55,0,0,0-2.07-.56,2.73,2.73,0,0,0-1.93,1.74,4.74,4.74,0,0,0-.32,1.59c-.65-1.54-2-2.51-3.32-2.25a2.56,2.56,0,0,0-1.72,1.29,4.59,4.59,0,0,0-.13,4.07C150.89,12.18,153.06,13.13,154.93,14.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M153.73,27.43a9.43,9.43,0,0,1,.78,2.49c0,.23.07.46.09.71s0,.29.08.3,0,0,0,0,0,0,0,0,.37-.56.43-.66A9.63,9.63,0,0,1,157,28.12c1.89-1.66,4.09-2.58,5-4.45a4.54,4.54,0,0,0-.06-4.08,2.58,2.58,0,0,0-1.69-1.32,2.71,2.71,0,0,0-2.45.85,4.48,4.48,0,0,0-.92,1.35,3.21,3.21,0,0,0-2.19-3.37,2.58,2.58,0,0,0-2.08.53,4.55,4.55,0,0,0-1.7,3.71C151,23.41,152.67,25.14,153.73,27.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M151.05,40.7a9.62,9.62,0,0,1,.78,2.5c0,.23.07.46.09.7s0,.3.08.31a0,0,0,0,0,0,0s0,0,0,0,.38-.56.44-.66a9.63,9.63,0,0,1,1.85-2.17c1.89-1.67,4.08-2.58,5-4.45a4.54,4.54,0,0,0-.06-4.08,2.58,2.58,0,0,0-1.69-1.32,2.73,2.73,0,0,0-2.46.85,4.57,4.57,0,0,0-.91,1.35,3.21,3.21,0,0,0-2.19-3.37,2.58,2.58,0,0,0-2.08.53,4.53,4.53,0,0,0-1.7,3.7C148.35,36.69,150,38.41,151.05,40.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M144.35,51.57a9.41,9.41,0,0,1-.24,2.6,5.91,5.91,0,0,1-.19.69c-.06.19-.07.29,0,.31h.05a.07.07,0,0,0,0,0c.12.07.56-.37.66-.44a9.22,9.22,0,0,1,2.54-1.29c2.39-.82,4.76-.83,6.32-2.2A4.53,4.53,0,0,0,155,47.5a2.57,2.57,0,0,0-1.05-1.87,2.71,2.71,0,0,0-2.59-.15,4.32,4.32,0,0,0-1.36.89,3.22,3.22,0,0,0-.73-3.95,2.59,2.59,0,0,0-2.13-.31,4.56,4.56,0,0,0-3,2.77C143.4,46.83,144.25,49.05,144.35,51.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M136.78,62.8a9.41,9.41,0,0,1-.24,2.6,5.91,5.91,0,0,1-.19.69c-.06.19-.07.29,0,.31h0s0,0,0,0,.56-.37.66-.44a9.09,9.09,0,0,1,2.54-1.29c2.39-.82,4.76-.82,6.32-2.2a4.52,4.52,0,0,0,1.51-3.79,2.6,2.6,0,0,0-1.05-1.87,2.72,2.72,0,0,0-2.59-.15,4.32,4.32,0,0,0-1.36.89,3.21,3.21,0,0,0-.74-4,2.56,2.56,0,0,0-2.12-.31,4.54,4.54,0,0,0-3,2.77C135.83,58.06,136.68,60.28,136.78,62.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M125.68,69.58a9.29,9.29,0,0,1-1.19,2.32c-.14.19-.28.38-.44.57s-.17.24-.15.27,0,0,0,0a0,0,0,0,0,0,0c.08.1.65-.14.77-.17a9.7,9.7,0,0,1,2.84-.24c2.52.14,4.72,1,6.69.34a4.58,4.58,0,0,0,2.82-2.95,2.56,2.56,0,0,0-.28-2.12,2.7,2.7,0,0,0-2.35-1.12,4.38,4.38,0,0,0-1.59.32c1.17-1.2,1.55-2.81.8-3.94a2.55,2.55,0,0,0-1.85-1.09A4.59,4.59,0,0,0,128,63.29C126.58,64.83,126.53,67.2,125.68,69.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M114.45,75.4a9.82,9.82,0,0,1-2,1.69c-.2.12-.4.24-.61.35s-.26.15-.26.2l0,0a0,0,0,0,0,0,0c0,.13.65.13.77.15a9.59,9.59,0,0,1,2.72.86c2.27,1.1,4,2.76,6,2.88A4.56,4.56,0,0,0,124.87,80a2.56,2.56,0,0,0,.56-2.07A2.73,2.73,0,0,0,123.69,76a4.5,4.5,0,0,0-1.59-.32,3.21,3.21,0,0,0,2.25-3.32,2.59,2.59,0,0,0-1.29-1.72,4.61,4.61,0,0,0-4.08-.13C117.1,71.36,116.15,73.53,114.45,75.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M101.17,78.08a9.75,9.75,0,0,1-2,1.69l-.62.35c-.18.09-.26.16-.25.2s0,0,0,0a.08.08,0,0,0,0,0c0,.13.66.13.78.15a9.52,9.52,0,0,1,2.71.86c2.28,1.1,4,2.76,6,2.88a4.55,4.55,0,0,0,3.73-1.64,2.56,2.56,0,0,0,.56-2.07,2.73,2.73,0,0,0-1.73-1.93,4.56,4.56,0,0,0-1.6-.32A3.22,3.22,0,0,0,111.08,75a2.58,2.58,0,0,0-1.3-1.72,4.59,4.59,0,0,0-4.07-.13C103.82,74,102.87,76.21,101.17,78.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M88.58,78.31a9.63,9.63,0,0,1-2.5.79c-.23,0-.46.07-.7.08s-.3,0-.31.09,0,0,0,0,0,0,0,0,.56.37.66.44a9.38,9.38,0,0,1,2.17,1.85c1.67,1.89,2.58,4.08,4.45,5a4.61,4.61,0,0,0,4.08-.06,2.58,2.58,0,0,0,1.32-1.69,2.73,2.73,0,0,0-.85-2.46,4.51,4.51,0,0,0-1.35-.91,3.21,3.21,0,0,0,3.37-2.19,2.57,2.57,0,0,0-.53-2.08,4.52,4.52,0,0,0-3.7-1.7C92.59,75.62,90.87,77.25,88.58,78.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M75.3,75.63a9.63,9.63,0,0,1-2.5.79c-.23,0-.46.07-.7.08s-.3,0-.31.09,0,0,0,0l0,0c0,.13.55.37.65.44A9.38,9.38,0,0,1,74.6,79c1.67,1.89,2.59,4.08,4.45,5a4.61,4.61,0,0,0,4.08-.06,2.58,2.58,0,0,0,1.32-1.69,2.71,2.71,0,0,0-.85-2.46,4.39,4.39,0,0,0-1.35-.91,3.21,3.21,0,0,0,3.37-2.19,2.53,2.53,0,0,0-.52-2.08,4.54,4.54,0,0,0-3.71-1.7C79.31,72.94,77.59,74.57,75.3,75.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M63.89,70.24A9.06,9.06,0,0,1,61.28,70a5.76,5.76,0,0,1-.68-.19c-.19-.06-.29-.07-.32,0s0,0,0,0,0,0,0,0,.37.56.44.65A9.87,9.87,0,0,1,62,73c.81,2.39.82,4.76,2.19,6.32A4.57,4.57,0,0,0,68,80.87a2.58,2.58,0,0,0,1.87-1.05A2.72,2.72,0,0,0,70,77.23a4.3,4.3,0,0,0-.89-1.37c1.55.65,3.19.39,4-.73A2.52,2.52,0,0,0,73.34,73a4.55,4.55,0,0,0-2.76-3C68.63,69.3,66.41,70.15,63.89,70.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M52.65,62.67a9,9,0,0,1-2.6-.23c-.23,0-.45-.12-.68-.19s-.29-.08-.32,0,0,0,0,0,0,0,0,0,.37.56.44.65a9.71,9.71,0,0,1,1.29,2.55c.81,2.38.82,4.76,2.19,6.32a4.57,4.57,0,0,0,3.79,1.51,2.58,2.58,0,0,0,1.87-1,2.74,2.74,0,0,0,.15-2.6,4.37,4.37,0,0,0-.89-1.36c1.55.65,3.19.39,3.95-.73a2.52,2.52,0,0,0,.31-2.12,4.55,4.55,0,0,0-2.76-3C57.4,61.73,55.18,62.57,52.65,62.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M44.9,52.56a9.18,9.18,0,0,1-2.33-1.19c-.19-.14-.38-.28-.56-.44s-.24-.17-.28-.15,0,0,0,0h0c-.11.08.13.65.16.77a9.7,9.7,0,0,1,.24,2.84c-.14,2.52-1,4.72-.34,6.69a4.6,4.6,0,0,0,3,2.82,2.59,2.59,0,0,0,2.13-.28,2.71,2.71,0,0,0,1.11-2.35,4.18,4.18,0,0,0-.32-1.59c1.2,1.17,2.81,1.55,3.94.8a2.55,2.55,0,0,0,1.09-1.85,4.54,4.54,0,0,0-1.45-3.81C49.65,53.46,47.27,53.41,44.9,52.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M37.32,41.33A9.29,9.29,0,0,1,35,40.14c-.19-.14-.38-.28-.57-.44s-.24-.17-.27-.15,0,0,0,0a0,0,0,0,0,0,0c-.1.08.14.65.17.77a9.7,9.7,0,0,1,.24,2.84c-.14,2.52-1,4.72-.34,6.69a4.56,4.56,0,0,0,3,2.81,2.52,2.52,0,0,0,2.12-.27,2.7,2.7,0,0,0,1.12-2.35A4.38,4.38,0,0,0,40,48.49c1.2,1.17,2.81,1.55,3.94.8a2.55,2.55,0,0,0,1.09-1.85,4.57,4.57,0,0,0-1.45-3.81C42.07,42.23,39.7,42.18,37.32,41.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M35.08,28.6a9.56,9.56,0,0,1-1.69-2c-.12-.19-.24-.4-.35-.61s-.15-.26-.2-.25,0,0,0,0a0,0,0,0,0,0,0c-.13,0-.13.66-.15.78a9.52,9.52,0,0,1-.86,2.71c-1.1,2.27-2.76,4-2.88,6.05A4.55,4.55,0,0,0,30.52,39a2.56,2.56,0,0,0,2.07.56,2.73,2.73,0,0,0,1.93-1.74,4.5,4.5,0,0,0,.32-1.59,3.21,3.21,0,0,0,3.32,2.25,2.56,2.56,0,0,0,1.72-1.29A4.59,4.59,0,0,0,40,33.14C39.12,31.25,37,30.3,35.08,28.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M32.4,15.32a9.45,9.45,0,0,1-1.69-2c-.12-.2-.24-.4-.35-.62s-.16-.26-.2-.25,0,0,0,0l0,0c-.13,0-.13.66-.15.78A9.42,9.42,0,0,1,29.08,16c-1.1,2.28-2.76,4-2.88,6.05a4.51,4.51,0,0,0,1.64,3.73,2.56,2.56,0,0,0,2.07.56,2.71,2.71,0,0,0,1.93-1.73,4.56,4.56,0,0,0,.32-1.6,3.21,3.21,0,0,0,3.32,2.26,2.58,2.58,0,0,0,1.72-1.3,4.55,4.55,0,0,0,.12-4.07C36.44,18,34.27,17,32.4,15.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M12.75,19.23a9.27,9.27,0,0,1,1.38,2.22c.09.21.18.43.26.66s.12.28.16.28,0,0,0,0,0,0,0,0,.23-.63.26-.74a9.39,9.39,0,0,1,1.26-2.56c1.41-2.09,3.3-3.52,3.72-5.56a4.52,4.52,0,0,0-1.07-3.93,2.53,2.53,0,0,0-2-.86,2.71,2.71,0,0,0-2.16,1.43,4.7,4.7,0,0,0-.55,1.54c-.42-1.63-1.61-2.78-3-2.72a2.55,2.55,0,0,0-1.88,1,4.52,4.52,0,0,0-.73,4C9.14,16,11.15,17.27,12.75,19.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M14.59,32.8a9.4,9.4,0,0,1,1.58,2.09c.11.2.21.41.31.63s.14.27.18.26,0,0,0,0,0,0,0,0,.16-.64.19-.76a9.64,9.64,0,0,1,1-2.66c1.22-2.21,3-3.81,3.22-5.87a4.53,4.53,0,0,0-1.42-3.82,2.55,2.55,0,0,0-2-.68,2.7,2.7,0,0,0-2,1.62,4.19,4.19,0,0,0-.41,1.58c-.57-1.58-1.86-2.63-3.2-2.45a2.55,2.55,0,0,0-1.78,1.2A4.54,4.54,0,0,0,9.94,28C10.71,29.92,12.83,31,14.59,32.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M18.43,46a9.49,9.49,0,0,1,1.84,1.85c.14.19.28.39.4.59s.18.25.22.24l0,0a0,0,0,0,0,0,0c.13,0,.08-.67.09-.79a9.48,9.48,0,0,1,.65-2.77c.92-2.35,2.45-4.17,2.41-6.25a4.57,4.57,0,0,0-1.92-3.6,2.6,2.6,0,0,0-2.11-.4,2.71,2.71,0,0,0-1.79,1.88,4.51,4.51,0,0,0-.2,1.62,3.21,3.21,0,0,0-3.49-2A2.54,2.54,0,0,0,13,37.82a4.53,4.53,0,0,0,.19,4.07C14.2,43.7,16.44,44.48,18.43,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M24.27,58.59a9.19,9.19,0,0,1,2.16,1.47c.17.16.34.32.5.5s.22.2.26.19a.05.05,0,0,0,0,0h.05c.12-.06-.05-.66-.07-.78a9.72,9.72,0,0,1,.11-2.85c.45-2.48,1.61-4.56,1.17-6.59a4.54,4.54,0,0,0-2.58-3.16,2.54,2.54,0,0,0-2.14,0,2.69,2.69,0,0,0-1.4,2.18,4.35,4.35,0,0,0,.12,1.63,3.21,3.21,0,0,0-3.81-1.29,2.59,2.59,0,0,0-1.31,1.7,4.55,4.55,0,0,0,1,4C19.67,57.11,22,57.44,24.27,58.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M202.28,211.48a81.65,81.65,0,1,0-81.65,81.65A81.65,81.65,0,0,0,202.28,211.48Zm-134.45,0a52.8,52.8,0,1,1,52.8,52.79A52.8,52.8,0,0,1,67.83,211.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M199.82,113.46A112.94,112.94,0,1,0,86.88,226.39,112.94,112.94,0,0,0,199.82,113.46Zm-186,0a73,73,0,1,1,73,73A73,73,0,0,1,13.85,113.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M-7.6,130.26a12.71,12.71,0,0,1-12.71-12.7A12.71,12.71,0,0,1-7.6,104.85,12.7,12.7,0,0,1,5.1,117.56,12.7,12.7,0,0,1-7.6,130.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M6.31,165.53a12.71,12.71,0,1,1,6.8-16.63A12.71,12.71,0,0,1,6.31,165.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M32.78,192.66a12.7,12.7,0,1,1-.16-18A12.7,12.7,0,0,1,32.78,192.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M105.59,207.59a12.71,12.71,0,1,1-12.93-12.47A12.7,12.7,0,0,1,105.59,207.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M140.6,193.06a12.7,12.7,0,1,1-16.74-6.51A12.7,12.7,0,0,1,140.6,193.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M167.27,166.12a12.71,12.71,0,1,1-18,.48A12.7,12.7,0,0,1,167.27,166.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M165.76,58.31a12.7,12.7,0,1,1-6.21,16.85A12.69,12.69,0,0,1,165.76,58.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M103,18.57a12.7,12.7,0,1,1,7.68,16.24A12.71,12.71,0,0,1,103,18.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M65.06,19.77a12.71,12.71,0,1,1,13.36,12A12.72,12.72,0,0,1,65.06,19.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M-8,99a12.7,12.7,0,0,1-8-16.11A12.71,12.71,0,0,1,.11,75a12.7,12.7,0,0,1,8,16.11A12.7,12.7,0,0,1-8,99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M111.05,198.71c3.73-1.67,7.4-3.44,11-5.44a55.91,55.91,0,0,1-7.49-5.81q-5.33,2.92-11,5.52A85.6,85.6,0,0,0,111.05,198.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M95.77,185.6c-3.68,1.5-7.44,2.88-11.25,4.16q2.92,3.57,6.27,6.94,5.65-1.77,11.13-3.89A86.26,86.26,0,0,1,95.77,185.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M78.53,181.26q-5.58,1.61-11.31,2.83,2.32,4.07,5.06,7.95,5.64-1.09,11.15-2.56A93.21,93.21,0,0,1,78.53,181.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M62.63,174.59c-3.7.63-7.42,1.11-11.17,1.47q1.66,4.47,3.76,8.83,5.53-.42,11-1.22Q64.2,179.2,62.63,174.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M48.34,165.69c-3.61.17-7.24.2-10.87.08.67,3.21,1.47,6.4,2.42,9.56,3.56.19,7.11.24,10.66.17Q49.22,170.63,48.34,165.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M35.87,154.71q-5.22-.44-10.42-1.28c.23,3.37.58,6.76,1.06,10.13q5.07.94,10.17,1.52Q36.07,159.89,35.87,154.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "97.94 247.32 113.85 243.91 274.04 75.76 261.54 73.49 97.94 247.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "211.55 62.13 246.2 70.08 83.17 235.96 50.23 221.47 211.55 62.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M73.76,214.93a21.86,21.86,0,0,1-1.7,5.7c-.22.48-.46,1-.74,1.44s-.29.61-.23.68a.11.11,0,0,0,.1,0s0,.09,0,.1c.22.21,1.41-.56,1.66-.68a21.61,21.61,0,0,1,6.24-1.72c5.69-.74,11,.32,15.08-2a10.38,10.38,0,0,0,5.07-7.76,5.87,5.87,0,0,0-1.5-4.64,6.16,6.16,0,0,0-5.71-1.51,10.15,10.15,0,0,0-3.43,1.37c2.13-3.16,2.3-6.92.16-9.13a5.8,5.8,0,0,0-4.59-1.65,10.3,10.3,0,0,0-7.91,4.81C73.79,204,74.68,209.27,73.76,214.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M95.7,193.34A21.64,21.64,0,0,1,94,199c-.23.48-.47,1-.74,1.43s-.29.62-.23.69a.09.09,0,0,1,.12.12c.22.21,1.41-.57,1.65-.68a22,22,0,0,1,6.25-1.73c5.68-.73,11,.33,15.07-2a10.36,10.36,0,0,0,5.08-7.76,5.82,5.82,0,0,0-1.51-4.63,6.14,6.14,0,0,0-5.7-1.52,10.07,10.07,0,0,0-3.43,1.37c2.13-3.16,2.3-6.92.16-9.13a5.85,5.85,0,0,0-4.59-1.65,10.32,10.32,0,0,0-7.91,4.81C95.73,182.36,96.61,187.68,95.7,193.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M117.63,171.75a21.27,21.27,0,0,1-1.7,5.7c-.22.48-.46,1-.73,1.44s-.3.61-.23.68,0,0,.09,0,0,.09,0,.1c.22.21,1.41-.56,1.66-.68a21.52,21.52,0,0,1,6.24-1.72c5.69-.73,11,.32,15.08-2a10.38,10.38,0,0,0,5.07-7.75,5.86,5.86,0,0,0-1.5-4.64,6.15,6.15,0,0,0-5.7-1.52,10.23,10.23,0,0,0-3.44,1.38c2.13-3.16,2.3-6.92.16-9.13a5.83,5.83,0,0,0-4.58-1.66,10.35,10.35,0,0,0-7.92,4.81C117.66,160.78,118.55,166.1,117.63,171.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M139.56,150.17a21.28,21.28,0,0,1-1.69,5.69c-.22.48-.47,1-.74,1.44s-.3.61-.23.68,0,0,.1,0,0,.08,0,.1c.22.21,1.4-.57,1.65-.68a21.69,21.69,0,0,1,6.25-1.73c5.69-.73,11,.33,15.07-2a10.36,10.36,0,0,0,5.07-7.76,5.79,5.79,0,0,0-1.5-4.64,6.14,6.14,0,0,0-5.7-1.51,10,10,0,0,0-3.43,1.37c2.13-3.16,2.3-6.92.16-9.14a5.88,5.88,0,0,0-4.59-1.65,10.37,10.37,0,0,0-7.92,4.82C139.6,139.19,140.48,144.51,139.56,150.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M161.5,128.58a21.75,21.75,0,0,1-1.7,5.7c-.22.47-.46.95-.73,1.43s-.3.61-.24.68.06,0,.11,0,0,.08,0,.1c.23.21,1.41-.57,1.66-.69a21.93,21.93,0,0,1,6.24-1.72c5.69-.73,11,.33,15.08-2a10.34,10.34,0,0,0,5.07-7.75,5.89,5.89,0,0,0-1.5-4.64,6.16,6.16,0,0,0-5.71-1.51,10,10,0,0,0-3.43,1.37c2.13-3.16,2.3-6.92.16-9.13a5.83,5.83,0,0,0-4.59-1.65,10.34,10.34,0,0,0-7.91,4.81C161.53,117.6,162.42,122.92,161.5,128.58Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.c2de6ec4142881acac51bb2bd04099cc.svg";
export { ForwardRef as ReactComponent };